const TOGGLE_SAVE_INVENTORY_MODAL = 'app/modal/TOGGLE_SAVE_INVENTORY_MODAL';

export const UPDATE_PROCESSED_CHANGES_NOTIFICATION = 'UPDATE_PROCESSED_CHANGES_NOTIFICATION';
export const SET_MARK_AS_CHECKED = 'SET_MARK_AS_CHECKED';

export default {
  TOGGLE_SAVE_INVENTORY_MODAL,
  UPDATE_PROCESSED_CHANGES_NOTIFICATION,
  SET_MARK_AS_CHECKED
};
